export const TEST_ID = 'partConditionField';

// ag-ui number inputs only emit onChange when they carry a form field name.
export const REMAINING_LIFE_INPUT_NAME = 'remainingLife';
